import { render, staticRenderFns } from "./project-switcher.vue?vue&type=template&id=14489804&scoped=true&"
import script from "./project-switcher.vue?vue&type=script&lang=js&"
export * from "./project-switcher.vue?vue&type=script&lang=js&"
import style0 from "./project-switcher.vue?vue&type=style&index=0&id=14489804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14489804",
  null
  
)

component.options.__file = "project-switcher.vue"
export default component.exports